'use client';

import {
  Button,
  Center,
  HStack,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IRedux } from '@/_store/types';
import customerService from '@/_service/customer.service';
import { useTranslations } from 'next-intl';

import { useRouter } from '@/i18n/navigation';
import Auth from '@/_components/Auth';
import User from '../../User';
import PageList from '../../PageList';
import { useTelegram } from '@/_providers/telegram';

const Mobile = () => {
  const { user } = useSelector((state: IRedux) => state.auth);

  const { webApp } = useTelegram();
  const t = useTranslations();
  const router = useRouter();

  const [balance, setBalance] = useState<{ balance: number; deposit: number }>({
    balance: 0,
    deposit: 0,
  });

  const { open: isAuth, onClose, onOpen } = useDisclosure();

  useEffect(() => {
    if (!(balance?.balance || balance?.deposit) && user?.phone) {
      customerService
        .getIikoCustomerInfo({ phone: user.phone })
        .then((res) => {
          setBalance({
            balance: res?.data?.balance || 0,
            deposit: +res?.data?.deposit || 0,
          });
        })
        .catch((err) => console.log(err));
    }
  }, [user?.phone, balance?.balance, balance?.deposit]);

  return (
    <Stack gap={0} minH='100vh' pt='var(--tg-content-safe-area-inset-top)'>
      {/* Page Title */}
      <Center
        w='full'
        pt={webApp?.isFullscreen ? 8 : 4}
        pb={4}
        bg='background.card'
      >
        <Text fontSize={20} fontWeight={600}>
          {t('profile')}
        </Text>
      </Center>

      {user?.id ? (
        <User balance={balance} />
      ) : (
        <Stack px={4} py={3} gap={3} bg='background.main'>
          {/* Unregistered User Card */}
          <HStack
            w='full'
            bg='background.card'
            p={4}
            rounded={16}
            justifyContent='space-between'
            alignItems='center'
          >
            <VStack gap={0} alignItems='start'>
              <Text fontSize={'sm'} color='text.muted'>
                {t('login_user_description')}
              </Text>
            </VStack>
            <Button
              onClick={onOpen}
              bg='primary'
              color='primary.text'
              _hover={{ bg: 'primary.hover' }}
              size='lg'
              rounded={12}
            >
              {t('login')}
            </Button>
          </HStack>
        </Stack>
      )}
      <PageList />
      <Auth
        open={isAuth}
        onClose={onClose}
        onLastConfirm={() => router.push('/profile')}
      />
    </Stack>
  );
};

export default Mobile;
